import { useStore } from './Store';

export class CompanyCompareUtils {
	static findCompaniesToCompare = (reportId: string, maxReturn = 2) => {
		const store = useStore();
		const q = store.createDataAccess(reportId);

		if (q == null) return [];

		if (
			reportId ==
			'AOMInfusions(ProjectAugusta)CIMCemEsendal'
		) {
			return [
				'VitalCare(ProjectShelby)CIPCemEsendal',
				'InfusionAssociates(ProjectSpartan)CIMCemEsendal'
			];
		}
		const companies = Object.keys(store.reportDataDB).filter(
			reportId => store.reportDataDB[reportId].status == 'completed'
		);

		const fullMatch = [];
		const partialMatch = [];
		const noMatch = [];

		const industry = q.value('industry');
		const subIndustry = q.value('industrySubType');

		companies.forEach(reportId => {
			const compA = store.createDataAccess(reportId);

			const otherIndustry = compA.value('industry');
			const otherSub = compA.value('industrySubType');

			if (store.selectedReportId == reportId) return;
			if (industry == otherIndustry && subIndustry == otherSub) {
				fullMatch.push(reportId);
			} else if (industry == otherIndustry) {
				partialMatch.push(reportId);
			} else {
				noMatch.push(reportId);
			}
		});

		var allCompanies = fullMatch.concat(partialMatch).concat(noMatch);
		return allCompanies.slice(0, maxReturn);
	};
}